import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { switchMap, catchError, tap, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LiveNursesService } from 'src/app/recruiting/candidates/live-nurses-new/live-nurses.service';
import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Injectable()
export class DeleteJobEffect {
    deleteJob$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.deleteJob),
            switchMap((action) => {
                return this.liveNursesService
                    .deleteJob(action.jobId, action.submittalId, action.submittalStatusId, action.submittalSubStatusId)
                    .pipe(
                        mergeMap(() => [
                            actions.modifyingJobs({ isBusy: true }),
                            actions.deleteJobSuccess({ jobId: action.jobId, submittalId: action.submittalId }),
                            actions.loadJobOptions({ submittalIds: [action.submittalId] }),
                            actions.modifyingJobs({ isBusy: false })
                        ]),
                        catchError((error) => of(actions.deleteJobFail({ error })))
                    );
            })
        )
    );

    deleteJobFail$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(actions.deleteJobFail),
                tap((action) => {
                    console.log(action.error);
                    this.toaster.toast('Sorry. A problem occurred while deleting a job.');
                })
            ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        protected liveNursesService: LiveNursesService,
        private toaster: ToasterService
    ) {}
}
